import React, { memo } from 'react'
import { Security } from '../../proto/generated/security'
import { OverviewWidgetResponse_FieldGroup } from '../../proto/generated/overview-widget'
import OverviewPerformanceSection from './OverviewPerformanceSection'

export type ScreenerOverviewRangeBlockProps = {
    securityForContent: Security | undefined
    displaySecurity: Security
    screenerTargetKey: string | null
    overviewSecurityKey: string | undefined
    fieldGroups: OverviewWidgetResponse_FieldGroup[]
}

const ScreenerOverviewRangeBlock = ({
    securityForContent,
    displaySecurity,
    fieldGroups
}: ScreenerOverviewRangeBlockProps) => {
    if (!securityForContent) return null

    return (
        <OverviewPerformanceSection
            security={securityForContent}
            surveillanceSecurity={displaySecurity}
            fieldGroups={fieldGroups}
        />
    )
}

const screenerRangeBlockPropsAreEqual = (prev: ScreenerOverviewRangeBlockProps, next: ScreenerOverviewRangeBlockProps) =>
    prev.securityForContent === next.securityForContent &&
    prev.displaySecurity?.exchange === next.displaySecurity?.exchange &&
    prev.displaySecurity?.code === next.displaySecurity?.code &&
    prev.fieldGroups === next.fieldGroups

export default memo(ScreenerOverviewRangeBlock, screenerRangeBlockPropsAreEqual)
